import {customAlphabet} from "nanoid";

const alphabet = '0123456789abcdefghijklmnopqrstuvwxyz';
export const generateExternalId = customAlphabet(alphabet, 10);